import React from 'react';
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from 'react-google-maps';
import MarkerClusterer from 'react-google-maps/lib/components/addons/MarkerClusterer';
import festivalMarker from '../../static/festival-marker.svg';
import propertyMarker from '../../static/property-marker.svg';

const mapStyles = [
  { featureType: 'landscape.man_made', elementType: 'geometry', stylers: [{ color: '#f7f1df' }] },
  { featureType: 'landscape.natural', elementType: 'geometry', stylers: [{ color: '#d0e3b4' }] },
  { featureType: 'landscape.natural.terrain', elementType: 'geometry', stylers: [{ visibility: 'off' }] },
  { featureType: 'poi', elementType: 'labels', stylers: [{ visibility: 'off' }] },
  { featureType: 'poi.business', stylers: [{ visibility: 'off' }] },
  { featureType: 'poi.medical', elementType: 'geometry', stylers: [{ color: '#fbd3da' }] },
  { featureType: 'poi.park', elementType: 'geometry', stylers: [{ color: '#bde6ab' }] },
  { featureType: 'road', elementType: 'geometry.stroke', stylers: [{ visibility: 'off' }] },
  { featureType: 'road', elementType: 'labels', stylers: [{ visibility: 'off' }] },
  { featureType: 'road.arterial', elementType: 'geometry.fill', stylers: [{ color: '#ffffff' }] },
  { featureType: 'road.highway', elementType: 'geometry.fill', stylers: [{ color: '#ffe15f' }] },
  { featureType: 'road.highway', elementType: 'geometry.stroke', stylers: [{ color: '#efd151' }] },
  { featureType: 'road.local', elementType: 'geometry.fill', stylers: [{ color: 'black' }] },
  { featureType: 'transit.station.airport', elementType: 'geometry.fill', stylers: [{ color: '#cfb2db' }] },
  { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#a2daf2' }] },
];

const Map = withScriptjs(
  withGoogleMap(props => {
    const { festival, properties } = props;
    return (
      <GoogleMap
        defaultZoom={15}
        defaultCenter={{ lat: parseFloat(festival.lat), lng: parseFloat(festival.lon) }}
        defaultOptions={{
          disableDefaultUI: true,
          styles: mapStyles,
        }}
      >
        <Marker position={{ lat: parseFloat(festival.lat), lng: parseFloat(festival.lon) }} options={{ icon: festivalMarker }} />
        {properties ? (
          <MarkerClusterer>
            {properties.map(property => {
              return (
                <Marker
                  key={property.id}
                  position={{ lat: parseFloat(property.location.lat), lng: parseFloat(property.location.lon) }}
                  defaultAnimation="drop"
                  options={{ icon: propertyMarker }}
                />
              );
            })}
          </MarkerClusterer>
        ) : null}
      </GoogleMap>
    );
  })
);

export default Map;
